module.exports = {
  "country": "UA",
  "artist": "Ruslana",
  "song": "Wild Dances",
  "year": "2004",
  "place": "1",
  "spotify": "1Lav2Z3RKu71MJLIjQz4dQ"
};